import { createFileRoute } from "@tanstack/react-router";
import { requerirConciliacionContrapago } from "@/features/solicitudes/utils/guard-edicion";
import { ConciliarCfdiContrapagoPage } from "@/features/conciliar-cfdi-contrapago/components/ConciliarCfdiContrapagoPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/conciliar-cfdi` · P44 FB60 Contrapago · último paso:
 * subir el CFDI real que llegó después del pago.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/conciliar-cfdi")({
  beforeLoad: requerirConciliacionContrapago,
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: ConciliarCfdiContrapagoPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
